module.exports = __webpack_public_path__ + "img/thumbblacksheep4.a4789b44.png";